export default {
  about: {
    omitInSections: false,
    omitInTabs: false,
    description: 'A global collective representing a myriad of backgrounds from artistry to aerospace, together we form Mind Makers. Our mission is to increase STEM accessibility for unconventional communities through education, outreach and awesome displays of tech teamwork. Our vision is of a diverse, technology proficient community that values knowledge sharing, redefines possibility and inspires a new wave of engineering enthusiasts.',
    path: '/about',
    title: 'About',
    buttonText: 'Learn More'
  },
  outreach: {
    omitInSections: false,
    omitInTabs: false,
    description: 'Mind Makers recognizes the impact of societal engagement and mentorship and we strive to educate and inspire our global neighbors through our outreach and service. Check out our latest happenings and get involved!',
    extraClassNames: 'background--dark outreach-container',
    path: '/outreach',
    title: 'Outreach',
    buttonText: 'Learn More'
  },
  materials: {
    omitInSections: false,
    omitInTabs: false,
    description: 'Mind Makers is building a free, approachable curriculum introducing fundamentals of robotics while illustrating its parallels with other STEM fields. We aim to inspire unconventional, stereotype-breaking people to learn new skills, both in theory through our online content and in practice through specially curated workshops. One by one, workshops incrementally build an awesome, interactive exhibit showcasing the connection between autonomous systems and our own human anatomy, while sending a powerful message about who can participate in such STEM magic!',
    path: '/materials',
    title: 'Materials',
    buttonText: 'Learn More'
  },
  news: {
    omitInSections: true,
    omitInTabs: true,
    description: 'We would not be here if not for all we have learned and all the mentorship we have received in our travels. We want to share our insights with you- what makes our team tick, what keeps us motivated and what keeps us moving forward into the tech world.',
    extraClassNames: 'background--dark outreach-container',
    path: '/our-voice',
    title: 'Our Voice',
    buttonText: 'View all Posts'
  },
  getInvolved: {
    omitInSections: false,
    omitInTabs: false,
    description: 'We’re building a one-of-a-kind, open-source curriculum with virtual content and collaborative hardware building modules. Our team is diverse, building content that ties together neuroscience, robotics, anatomy, data visualization, system networking and philosophy. Join our team!',
    extraClassNames: 'background--dark outreach-container',
    path: '/get-involved',
    title: 'Get Involved',
    buttonText: 'View Volunteer Opportunities'
  },
  donate: {
    omitInSections: true,
    omitInTabs: false,
    path: '/donate',
    title: 'Donate'
  }
};


// WEBPACK FOOTER //
// ./src/configs/section-config.js